import tanks from '@components/competitions/levels/tekyehmajazi/assets/images/t0/tanks.webp';
import winner from '@components/competitions/levels/tekyehmajazi/assets/images/t0/winner2.webp';
import {questions} from '@components/competitions/levels/tekyehmajazi/assets/questions';
import {Box, Card, CardContent, Typography, useTheme} from '@mui/material';
import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {Link, useNavigate} from 'react-router-dom';

type IProps = {
	state?: string;
};

export default function MissionCompleted({state}: IProps) {
	const theme = useTheme();
	const {t} = useTranslation();
	const today = new Date().getDate();
	const navigate = useNavigate();
	// const {
	// 	setMission
	// } = useCompetitionTekyehmajaziContext();
	const todayQuestions = questions[today] || [];
	useEffect(() => {
		const storedCompetitionDay = localStorage.getItem('competitionDay') ?? null;
		if (storedCompetitionDay) {
			const competitionDay = parseInt(storedCompetitionDay, 10);
			if (competitionDay !== today) {
				// setMission(0);
				navigate('/competition/tekyehmajazi');
			}
		}
	}, [today]);
	return (
		<div className="flex flex-col items-center justify-center pb-10">
			{/* Questions and Answers */}
			{todayQuestions.map((q, index) => (
				<Card key={index} className="w-full bg-transparent border-0 shadow-none p-0 m-0">
					<CardContent className="p-2">
						<Typography className="text-white">
							{index + 1}: {q.question}
						</Typography>
						<Typography className="mt-1 text-white">
							✅ {q.answers[q.correctAnswer]}
						</Typography>
					</CardContent>
				</Card>
			))}
			
			{/* Tanks Image */}
			<Box className="w-10/12 my-6">
				<img src={tanks} alt="content" className="w-full rounded-lg shadow-md"/>
			</Box>
			
			{/* Winner Image */}
			<Box className="w-4/12">
				<Link to={`/network/35`}>
					<img src={winner} alt="winner"
					     className="w-full rounded-lg shadow-md transition-transform transform hover:scale-105"/>
				</Link>
			</Box>
		</div>
	);
}
